import axios from 'axios';

import '../sass/news.scss';

(() => {
    const $news = document.querySelectorAll('.news');

    if (!$news) return;

    $news.forEach($news => {
        const $list = $news.querySelector('.news__list');
        const $loadMoreWrap = $news.querySelector('.news__load-more-wrap');
        const $loadMore = $news.querySelector('.news__load-more');

        const filterController = new AbortController();
        
        const loadMore = () => {
            if (!$list) return;

            const page = $list?.dataset?.page ? parseInt($list.dataset.page) : 1;
            const postsPerPage = $list?.dataset?.postsPerPage ? parseInt($list.dataset.postsPerPage) : 2;

            const nextPage = page + 1;

            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            axios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'sg_wireless_ajax_get_posts', 
                    posts_per_page: postsPerPage,
                    page: nextPage,
                    category: params.get('news_category'),
                },
                signal: filterController.signal,
            }).then(response => {
                if (response?.data?.html) {
                    $list.insertAdjacentHTML('beforeend', response.data.html);
                }

                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);

                $list.dataset.page = nextPage;

                if (!response?.data?.found_posts || postsPerPage * nextPage + 1 >= response.data.found_posts) {
                    $loadMoreWrap?.classList.add('news__load-more-wrap--hide');
                }

                params.delete('news_page');
                params.append('news_page', nextPage);

                window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
            });
        };

        const initLoadMore = () => {
            if (!$loadMore) return;

            $loadMore.addEventListener('click', e => {
                e.preventDefault();

                loadMore();
            });
        };

        initLoadMore();
    });
})();
